import { render, staticRenderFns } from "./ContractorDocumentInfoProvider.vue?vue&type=template&id=752a4ef6"
import script from "./ContractorDocumentInfoProvider.vue?vue&type=script&lang=ts"
export * from "./ContractorDocumentInfoProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752a4ef6')) {
      api.createRecord('752a4ef6', component.options)
    } else {
      api.reload('752a4ef6', component.options)
    }
    module.hot.accept("./ContractorDocumentInfoProvider.vue?vue&type=template&id=752a4ef6", function () {
      api.rerender('752a4ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ContractorDocumentInfoProvider.vue"
export default component.exports